import { Link } from "react-router-dom";
import { Facebook, Instagram, Youtube, MapPin, Mail, Phone, Globe } from "lucide-react";
import { NAV_LINKS, IMAGES } from "../data/site";
import { useSite } from "../context/SiteContext";

export default function Footer() {
  const { settings } = useSite();
  const college = settings.college;
  const social = settings.social;
  const logo = (settings.images && settings.images.logo) || IMAGES.logo;
  return (
    <footer data-testid="site-footer" className="relative bg-forest text-bone overflow-hidden">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 pt-24 pb-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-4 mb-6">
              <span className="w-14 h-14 rounded-full bg-white flex items-center justify-center overflow-hidden shrink-0">
                <img src={logo} alt="KCC logo" className="w-full h-full object-contain" />
              </span>
              <h2 className="font-serif text-3xl md:text-4xl leading-none tracking-tight">
                Kanggui <span className="italic text-gold">Christian</span> College
              </h2>
            </div>
            <p className="text-gold-light text-sm tracking-widest uppercase mb-1">{college.motto} · Founded {college.founded}</p>
            <p className="text-bone/60 max-w-md leading-relaxed mt-4">
              {college.affiliation}. Aff. No. {college.affNo}. A NEP 2020 &amp; FYUP compliant institution nurturing knowledge, character and community.
            </p>

            <div className="mt-8 space-y-3 text-sm text-bone/70">
              <p className="flex items-center gap-3"><MapPin size={16} className="text-gold" /> {college.location}</p>
              <p className="flex items-center gap-3"><Globe size={16} className="text-gold" /> {college.website}</p>
              <p className="flex items-center gap-3"><Phone size={16} className="text-gold" /> {college.phone}</p>
              <p className="flex items-center gap-3"><Mail size={16} className="text-gold" /> {college.email}</p>
            </div>

            <div className="mt-8">
              <p className="text-xs uppercase tracking-widest text-bone/40 mb-4">Follow @{social.handle}</p>
              <div className="flex items-center gap-4">
                <a href={social.facebook} target="_blank" rel="noopener noreferrer" data-testid="social-facebook" className="w-11 h-11 rounded-full border border-bone/20 flex items-center justify-center hover:bg-gold hover:border-gold hover:text-forest transition-colors"><Facebook size={18} /></a>
                <a href={social.instagram} target="_blank" rel="noopener noreferrer" data-testid="social-instagram" className="w-11 h-11 rounded-full border border-bone/20 flex items-center justify-center hover:bg-gold hover:border-gold hover:text-forest transition-colors"><Instagram size={18} /></a>
                <a href={social.youtube} target="_blank" rel="noopener noreferrer" data-testid="social-youtube" className="w-11 h-11 rounded-full border border-bone/20 flex items-center justify-center hover:bg-gold hover:border-gold hover:text-forest transition-colors"><Youtube size={18} /></a>
              </div>
            </div>
          </div>

          <div className="lg:col-span-2">
            <p className="text-xs uppercase tracking-widest text-bone/40 mb-6">Explore</p>
            <ul className="space-y-4">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`} className="text-bone/70 hover:text-gold transition-colors">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-5">
            <p className="text-xs uppercase tracking-widest text-bone/40 mb-6 flex items-center gap-2"><MapPin size={14} className="text-gold" /> Find us in Kangpokpi</p>
            <div className="rounded-sm overflow-hidden border border-bone/15">
              <iframe data-testid="kanggui-map" title="Kanggui Map" src="https://www.google.com/maps?q=Kangpokpi%2C%20Manipur&z=13&output=embed" width="100%" height="300" style={{ border: 0 }} loading="lazy" referrerPolicy="no-referrer-when-downgrade" className="map-frame" />
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-bone/15 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-bone/40">
          <p>© {new Date().getFullYear()} {college.name}. All rights reserved.</p>
          <p className="uppercase tracking-widest">Knowledge · Character · Community</p>
        </div>
      </div>
    </footer>
  );
}
